import {
  FinancialAccountPrimaryUse,
  type FinancialAccount,
} from '@/reducers/finances/financialAccountsReducer'
import type { PrimaryUseAnswer } from './types'

/**
 * Both questions are required: the declared use, and the follow-up it reveals asking
 * whether the account also carries charges of the other type. A null follow-up means it
 * was shown and skipped; a missing answer entirely means the account was never touched.
 */
export const isPrimaryUseAnswerComplete = (
  answer: PrimaryUseAnswer | undefined
): boolean => Boolean(answer?.primaryUse) && answer?.hasOtherType !== null

/** hasPersonalTransactions defaults to false, so only the stamp proves a business follow-up was answered. */
export const seedPrimaryUseAnswer = (
  account: Pick<
    FinancialAccount,
    | 'primaryUse'
    | 'primaryUseSetAt'
    | 'hasPersonalTransactions'
    | 'hasBusinessTransactions'
  >
): PrimaryUseAnswer => {
  if (account.primaryUse === FinancialAccountPrimaryUse.BUSINESS)
    return {
      primaryUse: account.primaryUse,
      hasOtherType: account.primaryUseSetAt
        ? account.hasPersonalTransactions
        : null,
    }
  return {
    primaryUse: account.primaryUse,
    hasOtherType: account.hasBusinessTransactions,
  }
}
